import React, { Component } from 'react';
import PageContent from './PageContent';
import data from '../data/dataEN.json';

class About extends Component {
  state = {
    cta: data.cta.sidebar,
    content: data.terms,
  };

  render() {
    return (
      <div>
        <PageContent cta={this.state.cta} content={this.state.content} />
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/Terms.js